var ___EXPOSE_LOADER_IMPORT___ = require("-!./ua-parser.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../../__virtual__/expose-loader-virtual-4803c07687/0/cache/expose-loader-npm-3.0.0-5d5de648f3-92d9fed7b9.zip/node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["UAParser"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["UAParser"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
